import * as types from './types';
import { createReducer } from '../../utils/reducerHelper';
import initialState from './initial-state';

const reducersMap = {
   [types.GET_WALLET_DATA_START]: (state) => ({
      ...state,
      isLoading: true,
   }),
   [types.GET_WALLET_DATA_COMPLETED]: (state, action) => ({
      ...state,
      balance: action.payload.balance || {},
      stats: action.payload.stats || {},
      payouts: action.payload.payouts || [],
      transactions: action.payload.transactions || [],
      payoutMethods: action.payload.payout_methods || [],
      settings: action.payload.settings || {},
      isLoading: false,
   }),
   [types.GET_WALLET_DATA_FAILED]: (state) => ({
      ...state,
      isLoading: false,
   }),
   [types.REQUEST_WITHDRAWAL_START]: (state) => ({
      ...state,
      isWithdrawing: true,
   }),
   [types.REQUEST_WITHDRAWAL_COMPLETED]: (state, action) => ({
      ...state,
      payouts: [action.payload, ...state.payouts],
      balance: {
         ...state.balance,
         available: state.balance.available - (action.payload.amount || 0),
      },
      isWithdrawing: false,
   }),
   [types.REQUEST_WITHDRAWAL_FAILED]: (state) => ({
      ...state,
      isWithdrawing: false,
   }),
   [types.UPDATE_PAYOUT_SETTINGS_START]: (state) => ({
      ...state,
      isSavingSettings: true,
   }),
   [types.UPDATE_PAYOUT_SETTINGS_COMPLETED]: (state, action) => ({
      ...state,
      settings: action.payload || state.settings,
      isSavingSettings: false,
   }),
   [types.UPDATE_PAYOUT_SETTINGS_FAILED]: (state) => ({
      ...state,
      isSavingSettings: false,
   }),
   [types.SET_ACTIVE_TAB]: (state, action) => ({
      ...state,
      activeTab: action.payload,
   }),
   [types.CONNECT_STRIPE_START]: (state) => ({
      ...state,
      isConnectingStripe: true,
   }),
   [types.CONNECT_STRIPE_COMPLETED]: (state, action) => {
      const data = action.payload || {};
      const payoutsEnabled = data.payouts_enabled || false;
      return {
         ...state,
         isConnectingStripe: false,
         stripeConnect: data,
         settings: payoutsEnabled
            ? { ...state.settings, stripe_connected: true, stripe_account_id: data.stripe_account_id }
            : state.settings,
      };
   },
   [types.CONNECT_STRIPE_FAILED]: (state) => ({
      ...state,
      isConnectingStripe: false,
   }),
   [types.LINK_BANK_ACCOUNT_START]: (state) => ({
      ...state,
      isLinkingBankAccount: true,
   }),
   [types.LINK_BANK_ACCOUNT_COMPLETED]: (state, action) => ({
      ...state,
      isLinkingBankAccount: false,
      payoutMethods: [...state.payoutMethods, action.payload],
   }),
   [types.LINK_BANK_ACCOUNT_FAILED]: (state) => ({
      ...state,
      isLinkingBankAccount: false,
   }),
};

export default createReducer(initialState)(reducersMap);
